import Vue from 'vue'

import Buefy from 'buefy'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'

import './main.scss'

import AppVue from './App.vue'
import CieVue from './Cie.vue'
import DefaultVue from './Default.vue'
import HRVue from './HR.vue'
import SettingsVue from './Settings.vue'

function getLocale() {
    let localeStorageLang = localStorage.getItem('cie_lang') || ''
    if (localeStorageLang) {
        return localeStorageLang
    }

    let lang = window.navigator.languages ? window.navigator.languages[0] : null
    lang = lang || window.navigator.language || window.navigator.userLanguage
    let shortLang = lang
    if (shortLang.indexOf('-') !== -1) {
        shortLang = shortLang.split('-')[0]
    }
    if (shortLang.indexOf('_') !== -1) {
        shortLang = shortLang.split('_')[0]
    }
    return shortLang.includes('fr') || shortLang.includes('en') ? shortLang : 'en'
}

Vue.use(Buefy, {
    defaultIconPack: 'fas'
})

const messages = {
  fr: {
      message: {
          title: 'Horodateur',
          enterpriseCode: 'Code d\'entreprise',
          time: {
              activity: 'Activité',
              start: 'Entrée',
              end: 'Sortie',
              worked: 'Temps travaillé',
          },
          connect: 'Connexion',
          logout: 'Déconnexion',
          punch: 'Pointer',
      },
      error: {
          'company-inactive': "L’horodateur n’est plus activé pour l’entreprise \"{0}\"",
          'company-not-found': "L'entreprise \"{0}\" n'a pas pu être trouvée",
          'employee-not-found': "Aucun employé trouvé dans la compagnie \"{0}\" pour le NIP fourni",
          'employee-not-a-user': "L'employé de la compagnie \"{0}\" avec le NIP fourni n'est pas un utilisateur",
          'no-activity-configured': "Aucune activité configurée dans le compte de la compagnie",
          'no-activity-provided': "Aucune activité fournie",
          'unable-to-update-punch': "Impossible de mettre à jour l'entrée de temps",
          'unable-to-get-punch': "Impossible d'obtenir l'entrée de temps",
      },
  },
  en: {
      message: {
          title: 'Time Clock',
          enterpriseCode: 'Company number',
          time: {
              activity: 'Activity',
              start: 'Start',
              end: 'End',
              worked: 'Worked time',
          },
          connect: 'Connect',
          logout: 'Logout',
          punch: 'Punch',
      },
      error: {
          'company-inactive': "The Time Clock is no longer enabled for the company \"{0}\"",
          'company-not-found': "The company \"{0}\" could not be found",
          'employee-not-found': "No employee found in company \"{0}\" with the provided PIN",
          'employee-not-a-user': "The employee of company \"{0}\" with the provided PIN is not a user",
          'no-activity-configured': "No activity configured in the company account",
          'no-activity-provided': "No activity provided",
          'unable-to-update-punch': "Unable to update punch",
          'unable-to-get-punch': "Unable to get punch",
      },
  }
}

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: getLocale(),
    messages,
})

Vue.use(VueRouter)

Vue.config.productionTip = false

const router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/ui/cie', component: CieVue},
        {path: '/ui/hr', component: HRVue},
        {path: '/ui/opt', component: SettingsVue},
        {path: '*', component: DefaultVue},
    ]
})

Vue.mixin({ methods: { getLocale } })

new Vue({
    render: h => h(AppVue),
    router,
    i18n
}).$mount('#app')
